<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="1100"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="form-head">
            Movimientos de Caja
        </div>
        <div class="pl-3 pt-3 pr-3">
            <Detail ref="detailCash"></Detail>
        </div>
    </v-navigation-drawer>
</template>

<script>
import Detail from './Detail'

export default {
    name: 'DetailCash',
    components: {
        Detail
    },
    data() {
        return {
            drawer: false,
            cash_id: null,
            cash_date: null
        }
    },
    methods: {
        clearData() {
            this.cash_id = null
            this.cash_date = null
        },
        
        showForm(cash_id, cash_date) {
            this.cash_id = cash_id
            this.cash_date = cash_date       
            this.drawer = !this.drawer;
            this.$refs.detailCash.restartTab();
        },
    }
}
</script>

<style>

</style>